import { React, useState, useEffect, useRef } from "react";
import { othersList } from "data/othersList";
import KeyProjectBox from "components/KeyProjectBox";
import YearBox from "components/YearBox";
import DescBox from "components/DescBox";
import "swiper/css";
import BackToBasic from "assets/images/backtobasic.png";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Works() {
  const [selectedYear, setSelectedYear] = useState(2024);
  const [projectsForYear, setProjectsForYear] = useState([]);
  const midCopyRef = useRef(null);

  useEffect(() => {
    // 선택된 연도에 해당하는 프로젝트를 필터링
    const filteredProjects = othersList.filter(
      (project) => parseInt(project.year) === selectedYear
    );
    setProjectsForYear(filteredProjects);
  }, [selectedYear]);

  useEffect(() => {
    const spans = gsap.utils.toArray(
      ".backtobasic-desc span",
      midCopyRef.current
    );
    spans.forEach((span) => {
      gsap.fromTo(
        span,
        { scale: 0.2 }, // 시작할 때 스케일
        {
          scale: 1, // 종료할 때 스케일
          scrollTrigger: {
            trigger: span,
            start: "top bottom", // 트리거가 뷰포트 하단에 도달했을 때 시작
            end: "center center", // 트리거가 뷰포트 중앙에 도달했을 때 종료
            scrub: true, // 스크롤 바를 움직이면서 애니메이션 효과가 부드럽게 적용됩니다
            markers: false, // 애니메이션의 시작과 끝을 표시하는 마커
            ease: "elastic.out(1,0.3)",
          },
        }
      );
    });
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Animate original circles
            gsap.fromTo(
              ".circle:first-child",
              {
                x: -300,
                opacity: 0,
              },
              {
                x: 0,
                opacity: 1,
                duration: 1,
                ease: "power2.out",
              }
            );

            gsap.fromTo(
              ".circle:last-child",
              {
                x: 300,
                opacity: 0,
              },
              {
                x: 0,
                opacity: 1,
                duration: 1,
                ease: "power2.out",
              }
            );

            // Animate text after circles are in place
            gsap.fromTo(
              [".circle:first-child span", ".circle:last-child span"],
              {
                opacity: 0,
              },
              {
                opacity: 1,
                duration: 0.5,
                delay: 1,
                ease: "power2.out",
              }
            );

            observer.disconnect();
          }
        });
      },
      {
        threshold: 0.8,
      }
    );

    const target = document.querySelector(".backtobasic-box");
    if (target) {
      observer.observe(target);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="app-works">
        <h2 className="header-copy">
          <strong className="main-text">
            This is
            <br />
            The Digital Works what
            <br />
            develops web apps & dashboards,
            <br />
            focus on modern web development.
          </strong>
        </h2>
        <section className="work-list-wrap">
          <KeyProjectBox />
        </section>
        <section className="backtobasic-wrap">
          <div className="backtobasic-inner">
            <img src={BackToBasic} alt="Back to Basic" />
          </div>
          <p className="backtobasic-desc" ref={midCopyRef}>
            <span>돋보이는 모션과 인터랙션으로 유저의 시선을 즐겁게</span>
            <span>그러나, 원칙을 지키며 장황하지 않게</span>
          </p>
          <div className="backtobasic-box">
            <div className="circle">
              <span>UX/UI</span>
            </div>
            <div className="circle">
              <span>
                INTER
                <br />
                ACTION
              </span>
            </div>
          </div>
        </section>
        <hr class="section-line" />
        <section className="other-works-section">
          <h3 className="head">그 밖에 작업들.</h3>
          <p className="sub">Other works</p>
          <div className="workbox-wrap">
            <div className="year-box">
              <YearBox setSelectedYear={setSelectedYear} />
            </div>
            <div className="desc-box">
              <div className="desc-box-inner">
                {projectsForYear.length > 0 ? (
                  projectsForYear.map((item) => (
                    <DescBox key={item.id} project={item} />
                  ))
                ) : (
                  <p style={{ fontSize: "1.8rem" }}>
                    선택된 연도에 해당하는 프로젝트 정보가 없습니다.
                  </p>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
